// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doc-preview {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #0008;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.doc-preview-cuerpo {
  width: min(1000px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.doc-preview-barra {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #e3e3e3;
}

.doc-preview-nombre { font-size: 14px; font-weight: 600; color: #1b1b1b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.doc-preview-cerrar {
  border-radius: 8px;
  padding: 8px 16px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  background: #111;
  border: 1px solid #111;
  color: #fff;
}

.doc-preview-cerrar:hover { background: #333; }

.doc-preview-visor { flex: 1 1; width: 100%; border: none; }
.doc-preview-imagen { flex: 1 1; min-height: 0; object-fit: contain; width: 100%; background: #f2f2f2; }
.doc-preview-cargando, .doc-preview-error { padding: 24px; text-align: center; color: #666; margin: 0; }
.doc-preview-error { color: #b71c1c; }
`, "",{"version":3,"sources":["webpack://./src/components/common/DocumentPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEzI;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA,4BAA4B,gBAAgB,EAAE;;AAE9C,qBAAqB,SAAO,EAAE,WAAW,EAAE,YAAY,EAAE;AACzD,sBAAsB,SAAO,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACrG,4CAA4C,aAAa,EAAE,kBAAkB,EAAE,WAAW,EAAE,SAAS,EAAE;AACvG,qBAAqB,cAAc,EAAE","sourcesContent":[".doc-preview {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: #0008;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n.doc-preview-cuerpo {\n  width: min(1000px, 100%);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.doc-preview-barra {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e3e3e3;\n}\n\n.doc-preview-nombre { font-size: 14px; font-weight: 600; color: #1b1b1b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.doc-preview-cerrar {\n  border-radius: 8px;\n  padding: 8px 16px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  background: #111;\n  border: 1px solid #111;\n  color: #fff;\n}\n\n.doc-preview-cerrar:hover { background: #333; }\n\n.doc-preview-visor { flex: 1; width: 100%; border: none; }\n.doc-preview-imagen { flex: 1; min-height: 0; object-fit: contain; width: 100%; background: #f2f2f2; }\n.doc-preview-cargando, .doc-preview-error { padding: 24px; text-align: center; color: #666; margin: 0; }\n.doc-preview-error { color: #b71c1c; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
